import styled from "@emotion/styled";
import React from "react";
import { APP_CONTENT_WIDTH } from "src/constants/layout";
import { getSupportedUserLanguage } from "src/lib/i18next";
import { getHeadingProps, useFocusHeading } from "src/lib/useFocusHeading";
import { KnownProgram } from "src/state/ProgramBloc/ProgramBloc";
import AppointmentsList from "src/ui/components/AppointmentsList/AppointmentsList";
import Branding from "src/ui/components/Branding/Branding";
import DailyReadingsWidget from "src/ui/components/DailyReadings/DailyReadingsWidget";
import MealInsightUploadCard from "src/ui/components/MealInsights/MealInsightUploadCard";
import PoweredByWidget from "src/ui/components/PoweredByWidget/PoweredByWidget";
import AppTopSpacer from "src/ui/components/StyledComponents/AppTopSpacer";
import CollectionTitle from "src/ui/components/StyledComponents/CollectionTitle";
import TaskList from "src/ui/components/TaskList/TaskList";
import Translate from "src/ui/components/Translate/Translate";
import UserEducationalFeed from "src/ui/components/UserEducationalFeed/UserEducationalFeed";
import UserEducationalFeedOld from "src/ui/components/UserEducationalFeed/UserEducationalFeedOld";
import SubscriptionCubit from "src/state/SubscriptionCubit/SubscriptionCubit";
import { MedicationSection } from "src/ui/components/MedicationSection/MedicationSection";
import { useBloc } from "src/state/state";

const Wrap = styled.div`
  label: HomePageWrap;
  max-width: ${APP_CONTENT_WIDTH}px;
  margin: 0 1.4rem;
  height: 100%;
`;

const Widgets = styled.div`
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const HomePage = () => {
  const { headingRef } = useFocusHeading();
  const language = getSupportedUserLanguage();

  const [
    { allSubscriptions },
    { getParsedMedsAlphabetically, getPrioritySubscription }
  ] = useBloc(SubscriptionCubit);

  const { subscription, parsedMeds, showMeds } = React.useMemo(() => {
    const sub = getPrioritySubscription();
    const meds = getParsedMedsAlphabetically(sub?.id);

    return {
      subscription: sub,
      parsedMeds: meds,
      showMeds: meds.length > 0
    };
  }, [allSubscriptions]);

  return (
    <Wrap>
      <AppTopSpacer pt />
      <h1 className="only-sr" ref={headingRef} {...getHeadingProps()}>
        <Translate msg="homePage" />
      </h1>
      <Widgets>
        <PoweredByWidget />
        <DailyReadingsWidget />
      </Widgets>
      <Branding
        style={{
          marginBlockEnd: "1.6em"
        }}
      />
      <AppointmentsList />
      <TaskList
        programs={[
          KnownProgram.ONBOARDING,
          KnownProgram.CARE,
          KnownProgram.MEAL_PLAN,
          KnownProgram.LIFEBALANCE,
          KnownProgram.BEHAVIORAL_HEALTH_SCREENING,
          KnownProgram.EDUCATION,
          KnownProgram.NUTRITION_JOURNEY,
          KnownProgram.MINDSET_JOURNEY,
          KnownProgram.PHYSICAL_ACTIVITY_JOURNEY,
          KnownProgram.EVERYDAY_DIABETES_JOURNEY
        ]}
        consolidateOnboardingTasks
      />
      <MealInsightUploadCard />
      {showMeds && (
        <div style={{ marginTop: "1.5rem" }}>
          <MedicationSection
            parsedMeds={parsedMeds}
            subscription={subscription}
          />
        </div>
      )}
      <CollectionTitle style={{ marginTop: "1.5rem", marginBottom: "0.75rem" }}>
        <Translate msg="articles.title" />
      </CollectionTitle>
      {language === "es" ? <UserEducationalFeedOld /> : <UserEducationalFeed />}
    </Wrap>
  );
};

export default HomePage;
